import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import React, { FC, useEffect, useState } from "react";
import { ResolveThunks, connect, useSelector } from "react-redux";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ADIXtenIntegrationHandler from "@NA/Handlers/ADIXtenIntegrationHandler";
import translate from "@insite/client-framework/Translate";
import { getLocation } from '@insite/client-framework/Store/Data/Pages/PageSelectors';
import Button from "@insite/mobius/Button";
import ADIXtenConfirmationModal from "@NA/Components/ADIXtenConfirmationModal";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import AdiXtenIntegrationHelper, { IsXtenAllowedUser, callToHandler, redirectAction } from "@NA/Hooks/useAdiXtenIntegrationHelper";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { text } from "express";
import { Link } from "react-router-dom";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface adiXtenIntegrationStyles {
    SignupButtonContainer?: InjectableCss;
    signUpButtonHide?: InjectableCss;
    signUpButtonDesign?: InjectableCss;
};

export const adiXtenIntegrationStyles: adiXtenIntegrationStyles = {
    SignupButtonContainer: {
        css: css`    
            .signUpButtonDesign {
                display: block !important;
                margin:10px auto 50px;   
                text-align: center !important; 
            }
        `,
    },
    signUpButtonHide :{
        css: css`
            display:none;
            .signUpButtonDesign {
                display:none !important;
            }
    `, 
    },
    signUpButtonDesign :{
        css: css`
             display:block;
            .signUpButtonDesign {
                display: block !important;
                margin:10px auto 50px;   
                text-align: center !important; 
            }

    `, 
    },
};
const styles = adiXtenIntegrationStyles;

const mapStateToProps = (state: ApplicationState) => ({
    location: getLocation(state)
});

const mapDispatchToProps = {
    ADIXtenIntegrationHandler,
    loadCurrentCart
};


type Props = ReturnType<typeof mapStateToProps> & HasHistory & ResolveThunks<typeof mapDispatchToProps>;
const ADIXtenIntegration: FC<Props> = ({ ADIXtenIntegrationHandler, location, history, loadCurrentCart }:
    {
        ADIXtenIntegrationHandler: any, location: any, history: any, loadCurrentCart: any
    }) => {
    const [id, setId] = useState('');
    const [type, setType] = useState('');
    const [listName, setListName] = useState('');
    const [cartPopupMessage, setCartPopupMessage] = useState('');
    const customerSettings = useSelector((state: ApplicationState) => getSettingsCollection(state).customerSettings);
    const allowedUserRole = customerSettings.allowedUserRole;
    const enableAdiXtenIntegration = customerSettings.enableAdiXtenIntegration;
    const adiXtenSignupUrl = customerSettings.adiXtenSignupUrl;
    const [userAlreadtSignup, SetUserAlreadtSignup] = useState(true);
    const { uniqueListName, isUserSignedUp } = enableAdiXtenIntegration ? AdiXtenIntegrationHelper() : { uniqueListName: "", isUserSignedUp: true };
    const toasterContext = React.useContext(ToasterContext);
    const [isADIXtenConfirmationModal, setIsADIXtenConfirmationModal] = useState(false);
   
    useEffect(() => {
        const currentUrl = location.search;
        const searchParams = new URLSearchParams(currentUrl);
        setId(searchParams.get("id") || "NewUser");
        const typeStr = searchParams.get("type") || "signUp"
        setType(typeStr.toLowerCase());
    }, [location]);


    useEffect(() => {
        if (type === "cart") {
            setListName(uniqueListName);
            if (isUserSignedUp) {
                //setCartPopupMessage(translate(`The cart items will be moved to "${uniqueListName}" and exported to XTEN`));
            }
            else {
                //setCartPopupMessage(translate(`The cart items will be moved to list "${uniqueListName}" and exported to XTEN when you sign up for free trial`));
            }
        }
    }, [type]);


    useEffect(() => {           
              if (!isUserSignedUp) {
                SetUserAlreadtSignup(true);
              } else {
                SetUserAlreadtSignup(false);
              }
          
    }, [isUserSignedUp]);

    if (!enableAdiXtenIntegration) {
        return <></>;
    }

    const ADIXtenConfirmationModalOpen = () => {
        setIsADIXtenConfirmationModal(true);
    };
    const closeCancel = () => {
        setIsADIXtenConfirmationModal(false);
    };

    const actionToXtenSignupPage = () => {
        //callToHandler(id, type, listName, toasterContext, ADIXtenIntegrationHandler, closeCancel, loadCurrentCart,false, "", SetUserAlreadtSignup);
    };

    const actionToXten = () => {
        callToHandler(id, type, listName, toasterContext, ADIXtenIntegrationHandler, closeCancel, loadCurrentCart, false, "", SetUserAlreadtSignup);
        SetUserAlreadtSignup(true);
    };



    const handleCartButtonAction = (IsTemp: boolean, ListNameInput: string) => {
        callToHandler(id, type, listName, toasterContext, ADIXtenIntegrationHandler, closeCancel, loadCurrentCart, IsTemp, ListNameInput, SetUserAlreadtSignup);
        SetUserAlreadtSignup(true);
    };

    const handleSignUpButtonClick = () => {
        if (type === "cart") {
            ADIXtenConfirmationModalOpen();
        }
        else {
            callToHandler(id, type, listName, toasterContext, ADIXtenIntegrationHandler, closeCancel, loadCurrentCart, false, "", SetUserAlreadtSignup);

            SetUserAlreadtSignup(true);

        }
    };

    const handleAlreadySignedup = () => {
        history.push("/");
    };
    return (
        <>
           {IsXtenAllowedUser(allowedUserRole) && (
                <StyledWrapper {...styles.SignupButtonContainer}>
                   
					<StyledWrapper {...(userAlreadtSignup ? styles.signUpButtonDesign : styles.signUpButtonHide )} style={{display : "none;"}}>
                        {userAlreadtSignup  && (
                            <Button className="signUpButtonDesign" onClick={handleSignUpButtonClick}>{translate("Sign up For Free Trial")}</Button>
                        )}
                    </StyledWrapper>
					


                    <ADIXtenConfirmationModal
                        isOpen={isADIXtenConfirmationModal}
                        handleClose={closeCancel}
                        actionToXten={actionToXten}
                        isCart={true}
                        listName={listName}
                        actionToXtenSignupPage={actionToXtenSignupPage}
                        isUserSignedUp={isUserSignedUp}
                        handleCartButtonAction={handleCartButtonAction}
                    />
                </StyledWrapper>              
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(ADIXtenIntegration)),
    definition: {
        displayName: "ADI XTen Integration",
        icon: "rewards",
        group: "Common",
    },
};

export default widgetModule;